/**
 * Mobile MERV Table JavaScript
 * Handles dropdown selection and table updates
 */

// MERV data configuration
const MERV_DATA = {
  'merv-6': {
    name: 'MERV 6',
    color: '#a2b6cd',
    compatibility: 'MPR 300 & FPR N/A',
    features: {
      'dust-lint': true,
      'mold-spores': false,
      'pollen': false,
      'pet-dander': false,
      'smog-smoke': false,
      'odor': false,
      'traps-odors': false,
      'cough-sneeze': false,
      'virus-bacteria': false
    }
  },
  'merv-8': {
    name: 'MERV 8',
    color: '#649a41',
    compatibility: 'MPR 600 & FPR 5',
    features: {
      'dust-lint': true,
      'mold-spores': true,
      'pollen': false,
      'pet-dander': false,
      'smog-smoke': false,
      'odor': false,
      'traps-odors': false,
      'cough-sneeze': false,
      'virus-bacteria': false
    }
  },
  'merv-11': {
    name: 'MERV 11',
    color: '#bb574f',
    compatibility: 'MPR 1000-2000 & FPR 7',
    features: {
      'dust-lint': true,
      'mold-spores': true,
      'pollen': true,
      'pet-dander': true,
      'smog-smoke': true,
      'odor': true,
      'traps-odors': false,
      'cough-sneeze': false,
      'virus-bacteria': false
    }
  },
  'merv-11-carbon': {
    name: 'MERV 11 + CARBON',
    color: '#faa61a',
    compatibility: 'MPR 1000-2000 & FPR 7',
    features: {
      'dust-lint': true,
      'mold-spores': true,
      'pollen': true,
      'pet-dander': true,
      'smog-smoke': true,
      'odor': true,
      'traps-odors': true,
      'cough-sneeze': true,
      'virus-bacteria': false
    }
  },
  'merv-13': {
    name: 'MERV 13',
    color: '#947dff',
    compatibility: 'MPR 1500-1900 & FPR 10',
    features: {
      'dust-lint': true,
      'mold-spores': true,
      'pollen': true,
      'pet-dander': true,
      'smog-smoke': true,
      'odor': true,
      'traps-odors': false,
      'cough-sneeze': true,
      'virus-bacteria': true
    }
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initializeMobileTable();
});

function initializeMobileTable() {
  const leftSelect = document.getElementById('merv-left');
  const rightSelect = document.getElementById('merv-right');
  
  if (!leftSelect || !rightSelect) {
    return;
  }
  
  // Add event listeners
  leftSelect.addEventListener('change', function() {
    handleDropdownChange('left', this.value);
  });
  
  rightSelect.addEventListener('change', function() {
    handleDropdownChange('right', this.value);
  });
  
  // Initial update
  updateTable();
}



function handleDropdownChange(side, newValue) {
  const leftSelect = document.getElementById('merv-left');
  const rightSelect = document.getElementById('merv-right');
  const leftValue = leftSelect.value;
  const rightValue = rightSelect.value;
  
  // Prevent selecting the same MERV type in both dropdowns
  if (leftValue === rightValue) {
    // Find an alternative option
    const allOptions = ['merv-6', 'merv-8', 'merv-11', 'merv-11-carbon', 'merv-13'];
    const availableOptions = allOptions.filter(option => option !== newValue);
    
    if (side === 'left') {
      // Update right dropdown to a different option
      rightSelect.value = availableOptions[0];
    } else {
      // Update left dropdown to a different option
      leftSelect.value = availableOptions[0];
    }
  }
  
  updateTable();
}

function updateTable() {
  const leftSelect = document.getElementById('merv-left');
  const rightSelect = document.getElementById('merv-right');
  
  if (!leftSelect || !rightSelect) {
    return;
  }
  
  const leftValue = leftSelect.value;
  const rightValue = rightSelect.value;
  
  // Update dropdown headers
  updateDropdownHeaders(leftValue, rightValue);
  
  // Update table content
  updateTableContent(leftValue, rightValue);
}

function updateDropdownHeaders(leftValue, rightValue) {
  const leftSelect = document.getElementById('merv-left');
  const rightSelect = document.getElementById('merv-right');
  
  // Find containers by their child select elements
  const leftContainer = leftSelect ? leftSelect.closest('.mobile-dropdown-container') : null;
  const rightContainer = rightSelect ? rightSelect.closest('.mobile-dropdown-container') : null;
  
  if (leftContainer) {
    // Update left dropdown
    const leftData = MERV_DATA[leftValue];
    const leftHeader = leftContainer.querySelector('.mobile-dropdown-header');
    const leftText = leftContainer.querySelector('.dropdown-text');
    
    if (leftHeader && leftText && leftData) {
      leftHeader.className = `mobile-dropdown-header ${leftValue}`;
      leftText.textContent = leftData.name;
      leftContainer.setAttribute('data-merv', leftValue);
    }
  }
  
  if (rightContainer) {
    // Update right dropdown
    const rightData = MERV_DATA[rightValue];
    const rightHeader = rightContainer.querySelector('.mobile-dropdown-header');
    const rightText = rightContainer.querySelector('.dropdown-text');
    
    if (rightHeader && rightText && rightData) {
      rightHeader.className = `mobile-dropdown-header ${rightValue}`;
      rightText.textContent = rightData.name;
      rightContainer.setAttribute('data-merv', rightValue);
    }
  }
}

function updateTableContent(leftValue, rightValue) {
  const leftData = MERV_DATA[leftValue];
  const rightData = MERV_DATA[rightValue];
  
  if (!leftData || !rightData) {
    return;
  }
  
  // Update compatibility row
  const leftCompatibility = document.querySelector('.mobile-cell.left-cell[data-compatibility]');
  const rightCompatibility = document.querySelector('.mobile-cell.right-cell[data-compatibility]');
  
  if (leftCompatibility && rightCompatibility) {
    leftCompatibility.textContent = leftData.compatibility;
    leftCompatibility.setAttribute('data-compatibility', leftValue);
    rightCompatibility.textContent = rightData.compatibility;
    rightCompatibility.setAttribute('data-compatibility', rightValue);
  }
  
  // Update feature rows
  Object.keys(leftData.features).forEach(feature => {
    const leftFeatureCell = document.querySelector(`.mobile-cell.left-cell[data-feature="${feature}"]`);
    const rightFeatureCell = document.querySelector(`.mobile-cell.right-cell[data-feature="${feature}"]`);
    
    if (leftFeatureCell && rightFeatureCell) {
      // Update left cell
      const leftIcon = leftFeatureCell.querySelector('.merv-icon');
      if (leftIcon) {
        leftIcon.className = leftData.features[feature] ? 'merv-icon check-icon' : 'merv-icon minus-icon';
      }
      
      // Update right cell
      const rightIcon = rightFeatureCell.querySelector('.merv-icon');
      if (rightIcon) {
        rightIcon.className = rightData.features[feature] ? 'merv-icon check-icon' : 'merv-icon minus-icon';
      }
    }
  });
}